export default "__VITE_ASSET__BL$R2HOG__"